import LocalStorage from "./localStorage";
import events from "../services/events";
import watcherList from "./stateWatchers";
import { localeInitActions, localeGetActions } from "Actions/localeActions";
import { deepAccess } from "./utils";

const storesToOmit = ['form', 'user'];

const StoreSvc = (() => {
  const svc = {
    watcherList: watcherList,
    oldStore: null,
    helpers: {
      storeChanged: currentStore => {
        if (currentStore !== svc.oldStore) {
          return true;
        } else {
          return false;
        }
      }
    }
  };

  const publicMethods = {
    update: Store => {
      let currentStore = Store.getState();

      let storeToSave = {};

      Object.keys(currentStore).forEach(key => {
        if(storesToOmit.includes(key)) {
            return;
        }

        storeToSave[key] = currentStore[key];
      })

      let stringifiedStore = JSON.stringify(storeToSave);
      if (svc.helpers.storeChanged(stringifiedStore)) {
        const stringified = true;
        LocalStorage.saveState(stringifiedStore, stringified);
        //events.broadcast('storeUpdated', currentStore);
        //publicMethods.checkWatchers(currentStore);
        svc.oldStore = stringifiedStore;
      }
    },
    initialDispatches: Store => {
      let currentStore = Store.getState();
      //console.log("preloaded: "+currentStore.locale.preloaded)
      //console.log(currentStore.locale)
      //only run this initial dispatch if we are not preloading
      //simplest solution for an ugly problem
      if (window.location.hash.indexOf("/pl/") === -1 && !currentStore.locale.preloaded) {
        Store.dispatch(localeInitActions.initGeoData());
      }
      Store.dispatch(localeInitActions.initCountries());

      // the condition above just check if translate in local is empty but not detect if translate in database has change
      Store.dispatch(localeGetActions.getTranslations());
    },
    checkWatchers: state => {
      for (let i in svc.watcherList) {
        if (svc.watcherList.hasOwnProperty(i)) {
          let currentValue = deepAccess(state, i);
          let cachedValue = svc.watcherList[i];
          let keyArr = i.split(".");
          let key = keyArr[keyArr.length - 1];
          if (currentValue !== cachedValue) {
            events.broadcast(key + "Updated", currentValue);
          }
        }
      }
    }
  };
  return publicMethods;
})();

export default StoreSvc;



// WEBPACK FOOTER //
// ./src/services/store.js